	<div class="layout">
		<main class="main">
			@if (!!(authService.userData$ | async)?.sessionID) {
				<router-outlet></router-outlet>
				<app-spinner [isLoading]="(isLoading$ | async)"></app-spinner>
			} @else {
				<div class="sign-in-content">
					<div>Please sign in.</div>
					<p-button label="Sign in" (onClick)="authService.login()"></p-button>
				</div>
			}
		</main>
	</div>
